import { IsNumber } from 'class-validator';

export class SitemapCreateDto {
  @IsNumber()
  id: number;
}
